import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import SignInPage from '../views/auth/SignInPage'
import SignUpPage from '../views/auth/SignUpPage'
import GetInTouch from '../views/GetInTouch'
import CaterWithBuildabox from '@/views/CaterWithBuildabox'
import Account from '../views/Account'
import ForgotPassword from '../views/auth/ForgotPasswordPage'
import ResetPassword from '../views/ResetPassword'
import store from '../store'
import LinkedinCallback from '../components/common/auth/LinkedinCallback'
import TwitterCallback from '../components/common/auth/TwitterCallback'
import AccountVerification from '../views/auth/AccountVerification'
import HowItWorks from '@/views/HowItWorks'
import PrivacyPolicy from '@/views/PrivacyPolicy'
import Segmentation from '@/views/segmentation/Segmentation'
import SegmentationStep from '@/views/segmentation/SegmentationStep'

import VueHead from 'vue-head'

Vue.use(VueHead)

Vue.use(VueRouter)

const authOnlyGuard = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next()
  } else {
    store.commit('setAuthRedirect', to.path)
    next('/auth/sign-in')
  }
}

const guestOnlyGuard = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next()
  } else {
    next('/')
  }
}

const eventPlannerOnlyGuard = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    store.commit('setAuthRedirect', to.path)
    next('/auth/sign-in')
  }

  let timer = setInterval(() => {
    if (store.getters.personalDetails !== null) {
      clearInterval(timer)

      if (store.getters.personalDetails?.roles.indexOf('event_planner') > -1) {
        next()
      } else {
        next('/')
      }
    }
  }, 500)

}

const routes = [
  {
    path     : '/',
    name     : 'Home',
    component: Home
  },
  {
    path     : '/segmentation',
    name     : 'segmentation-wizard',
    component: Segmentation,
    redirect : { name: 'segmentation-step', params: { id: '1' } },
    children : [{
      path     : 'step-:id',
      name     : 'segmentation-step',
      component: SegmentationStep
    }]
  },
  {
    path       : '/auth',
    name       : 'Auth',
    component  : () => import('../views/auth/AuthPage'),
    beforeEnter: guestOnlyGuard
  },
  {
    path       : '/auth/sign-in',
    component  : SignInPage,
    beforeEnter: guestOnlyGuard
  },
  {
    path     : '/auth/sign-in/twitter',
    component: TwitterCallback
  },
  {
    path     : '/auth/sign-in/linkedin',
    component: LinkedinCallback
  },
  {
    path       : '/auth/sign-up',
    component  : SignUpPage,
    beforeEnter: guestOnlyGuard,
  },
  {
    path     : '/auth/sign-up/linkedin',
    component: LinkedinCallback,
  },

  {
    path     : '/pricing',
    component: () => import('../views/PricingPage'),
  },

  {
    path     : '/salesforce/callback',
    component: () => import('../views/auth/SalesForceCallback'),
  },
  {
    path       : '/orders',
    props      : (route) => ({
      items_per_page: route.query.items_per_page,
      page          : route.query.page
    }),
    name       : 'orders.index',
    component  : () => import('../views/orders/index'),
    beforeEnter: authOnlyGuard
  },
  {
    path     : '/orders/:uuid',
    name     : 'orders.show',
    component: () => import('../views/orders/_uuid/index')
  },
  {
    path       : '/orders/:uuid/collaborators/create',
    name       : 'orders.collaborators.create',
    component  : () => import('../views/orders/_uuid/collaborators/create'),
    beforeEnter: authOnlyGuard
  },
  {
    path       : '/orders/:uuid/messages',
    name       : 'orders.messages.index',
    component  : () => import('../views/orders/_uuid/messages/index'),
    beforeEnter: authOnlyGuard
  },
  {
    path     : '/orders/:uuid/messages/create',
    name     : 'orders.messages.create',
    component: () => import('../views/orders/_uuid/messages/create')
  },
  {
    path     : '/orders/:uuid/messages/:id/edit',
    name     : 'orders.messages.edit',
    component: () => import('../views/orders/_uuid/messages/_id/edit')
  },
  {
    path       : '/orders/:uuid/attendees/:id',
    name       : 'orders.attendees.show',
    component  : () => import('../views/orders/_uuid/attendees/_id/index'),
    beforeEnter: authOnlyGuard
  },
  {
    path     : '/orders/:uuid/invite',
    name     : 'orders.invite',
    component: () => import('../views/orders/_uuid/invite'),
  },
  {
    path     : '/orders/:uuid/edit',
    name     : 'orders.edit',
    component: () => import('../views/orders/_uuid/edit/index'),
    redirect : { name: 'orders.edit.details' },
    children : [{
      path     : 'details',
      name     : 'orders.edit.details',
      component: () => import('../views/orders/_uuid/edit/details')
    }, {
      path     : 'menu',
      name     : 'orders.edit.menu',
      component: () => import('../views/orders/_uuid/edit/menu')
    }, {
      path     : 'categories',
      name     : 'orders.edit.categories',
      component: () => import('../views/orders/_uuid/edit/categories')
    }, {
      path     : 'items',
      name     : 'orders.edit.items',
      component: () => import('../views/orders/_uuid/edit/items')
    }, {
      path     : 'characters',
      name     : 'orders.edit.characters',
      component: () => import('../views/orders/_uuid/edit/characters')
    }, {
      path     : 'messages',
      name     : 'orders.edit.messages',
      component: () => import('../views/orders/_uuid/edit/messages')
    }, {
      path     : 'review',
      name     : 'orders.edit.review',
      component: () => import('../views/orders/_uuid/edit/review')
    }, {
      path     : 'portals',
      name     : 'orders.edit.portals',
      component: () => import('../views/orders/_uuid/edit/portals')
    }, {
      path     : 'integration',
      name     : 'orders.edit.integration',
      component: () => import('../views/orders/_uuid/edit/integration')
    }, {
      path     : 'attendees',
      name     : 'orders.edit.attendees',
      component: () => import('../views/orders/_uuid/edit/attendees')
    }, {
      path     : 'finalize',
      name     : 'orders.edit.finalize',
      component: () => import('../views/orders/_uuid/edit/finalize')
    }, {
      path     : 'confirmation',
      name     : 'orders.edit.confirmation',
      component: () => import('../views/orders/_uuid/edit/confirmation')
    }, {
      path     : 'success',
      name     : 'orders.edit.success',
      component: () => import('../views/orders/_uuid/edit/success')
    }]
  },
  {
    path       : '/events',
    name       : 'events.index',
    component  : () => import('../views/events/index'),
    beforeEnter: authOnlyGuard
  },
  {
    path       : '/events/:uuid',
    name       : 'events.show',
    component  : () => import('../views/events/uuid/index'),
    beforeEnter: authOnlyGuard
  },
  {
    path     : '/events/:uuid/edit',
    name     : 'events.edit',
    component: () => import('../views/events/uuid/edit/index')
  },
  {
    path     : '/how-it-works',
    name     : 'HowItWorks',
    component: HowItWorks
  },
  {
    path     : '/get-in-touch',
    name     : 'GetInTouch',
    component: GetInTouch
  },
  {
    path     : '/cater-with-buildabox',
    name     : 'CaterWithBuildabox',
    component: CaterWithBuildabox
  },
  {
    path     : '/privacy-policy',
    name     : 'Privacy Policy',
    component: PrivacyPolicy
  },
  {
    path       : '/account',
    component  : Account,
    beforeEnter: authOnlyGuard,
  },
  {
    path       : '/account/section-:section',
    component  : Account,
    beforeEnter: authOnlyGuard,
  },
  {
    path     : '/forgot-password',
    component: ForgotPassword
  },
  {
    path     : '/account/setpassword',
    component: () => import('../views/auth/CompleteRegistrationPage')
  },
  {
    path     : '/account/verify/:id',
    component: AccountVerification,
  },
  {
    path     : '/reset-password',
    component: ResetPassword
  },
  {
    path       : '/caterer/dashboard/:uuid?',
    name       : 'caterer.dashboard',
    component  : () => import('../views/caterer/dashboard'),
    beforeEnter: authOnlyGuard,
  },
  {
    path     : '/caterer/my-business/:uuid',
    name     : 'caterer.signup',
    component: () => import('../views/caterer/signup'),
    redirect : { name: 'caterer.signup.details' },
    children : [{
      path     : 'details',
      name     : 'caterer.signup.details',
      component: () => import('../views/caterer/signup/details')
    }, {
      path     : 'categories',
      name     : 'caterer.signup.categories',
      component: () => import('../views/caterer/signup/categories')
    }, {
      path     : 'items',
      name     : 'caterer.signup.items',
      component: () => import('../views/caterer/signup/items')
    }, {
      path     : 'review',
      name     : 'caterer.signup.review',
      component: () => import('../views/caterer/signup/review')
    }, {
      path     : 'success',
      name     : 'caterer.signup.success',
      component: () => import('../views/caterer/signup/success')
    }]
  },

  {
    path     : '/caterers/',
    component: () => import('../views/caterer/listing'),
  },
  {
    path     : '/caterers/:uuid/order',
    component: () => import('../views/caterer/makeOrder'),
  },
  {
    path     : '/caterers/:slug',
    component: () => import('../views/caterer/publicPage'),
  },

  {
    path     : '/event-planner/:uuid/my-business/',
    name     : 'event-planner.signup',
    component: () => import('../views/event-planner/signup'),
    redirect : { name: 'event-planner.signup.details' },
    children : [{
      path     : 'details',
      name     : 'event-planner.signup.details',
      component: () => import('../views/event-planner/signup/details')
    }, {
      path     : 'categories',
      name     : 'event-planner.signup.categories',
      component: () => import('../views/event-planner/signup/categories')
    }, {
      path     : 'items',
      name     : 'event-planner.signup.items',
      component: () => import('../views/event-planner/signup/items')
    }, {
      path     : 'review',
      name     : 'event-planner.signup.review',
      component: () => import('../views/event-planner/signup/review')
    }, {
      path     : 'success',
      name     : 'event-planner.signup.success',
      component: () => import('../views/event-planner/signup/success')
    }]
  },

  {
    path       : '/event-planner/dashboard/:uuid?',
    name       : 'event-planner.dashboard',
    component  : () => import('../views/event-planner/dashboard'),
    beforeEnter: eventPlannerOnlyGuard,
  },

  {
    path     : '/event-planners/:uuid/order',
    component: () => import('../views/event-planner/makeOrder'),
  },

  {
    path     : '/event-planners/:slug',
    component: () => import('../views/event-planner/publicPage')
  },

  {
    path     : '/promotions',
    component: () => import('../views/promotion/index')
  },
  {
    path     : '/promotions/:id/details',
    component: () => import('../views/promotion/details')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router
